<template>
  <v-flex xs12 :class="!subjectObj ? 'mb-4' : ''">
    <v-card>
      <v-card-title>
        <div class="flex-container-space-between">
          <layout-no-padding>
            <page-title :routeProps="routeProps"></page-title>
          </layout-no-padding>

          <div class="text-xs-right">
            <v-btn icon flat color="grey" class="mr-0" @click="drawer = !drawer">
              <v-icon>playlist_add</v-icon>
            </v-btn>
          </div>
        </div>
        <filter-drawer></filter-drawer>
      </v-card-title>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12 sm6 md3>
            <v-autocomplete
              :prepend-icon="$store.state.global.pages.client.icon"
              :color="$store.state.global.pages.client.color"
              label="Masterfile"
              :items="models"
              v-model="model"
              item-text="text"
              :clearable="true"
              item-value="value"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 sm6 md3>
            <v-text-field
              label="Filter by..."
              v-model="filterBy"
              prepend-icon="filter_list"
              :clearable="true"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-checkbox
              :color="$store.state.global.pages.compliance.color"
              label="Show Only Inactive"
              v-model="showInactive"
            ></v-checkbox>
          </v-flex>
        </v-layout>
      </v-container>
      <div class="mx-3 mb-5">
        <div class="flex-container-space-between">
          <div></div>
          <div>
            <compliance-chip-display></compliance-chip-display>
          </div>
        </div>
        <card-divider-full></card-divider-full>
      </div>
      <v-card-actions></v-card-actions>
      <v-btn
        fab
        dark
        :color="$store.state.global.pages[$route.name].color"
        class="overlap-fab"
        @click="addDialog = !addDialog"
        v-if="userAuthClass"
      >
        <v-icon dark>add</v-icon>
      </v-btn>
    </v-card>
    <control-info-display :data="subjectObj" route="compliance" v-model="showDetails"></control-info-display>
    <v-dialog v-model="addDialog" lazy max-width="700px">
      <add-compliance-resource @close="addDialog = false" title="Add Compliance Resources"></add-compliance-resource>
    </v-dialog>
  </v-flex>
</template>

<script>
import Store from "@/store/computed/storeHelpers";

// MIXINS
import RouteProps from "@/services/mixins/routeProps";
import models from "./mixins/models";
import getContractors from "@/services/mixins/getMasterFiles/getContractors";
import getVehicles from "@/services/mixins/getMasterFiles/getVehicles";
import getDrivers from "@/services/mixins/getMasterFiles/getDrivers";

// COMPONENTS
import ControlInfoDisplay from "@/components/ui/controlInfoDisplay";
import FilterDrawer from "@/modules/complianceResources/filterDrawer";
import AddComplianceResource from "./addComplianceResource";
import ComplianceChipDisplay from "@/modules/complianceResources/complianceChipDisplay";

export default {
  mixins: [RouteProps, models, getContractors, getVehicles, getDrivers],
  components: {
    ControlInfoDisplay,
    FilterDrawer,
    AddComplianceResource,
    ComplianceChipDisplay
  },
  data() {
    return {
      addDialog: false
    };
  },
  computed: {
    contractorId: Store.getSet({ store: "compliance", prop: "contractorId" }),
    vehicleId: Store.getSet({ store: "compliance", prop: "vehicleId" }),
    driverId: Store.getSet({ store: "compliance", prop: "driverId" }),
    model: Store.getSet({ store: "compliance", prop: "model" }),
    drawer: Store.getSet({ store: "compliance", prop: "drawer" }),
    filterBy: Store.getSet({ store: "compliance", prop: "filterBy" }),
    showDetails: Store.getSet({ store: "compliance", prop: "showDetails" }),
    resourceTypes: Store.getSet({ store: "compliance", prop: "resourceTypes" }),
    showInactive: Store.getSet({ store: "compliance", prop: "showInactive" }),
    subjectObj() {
      if (!!this.contractorId) {
        return this.getObjByPrimaryId(this.contractorId, this.contractors);
      } else if (!!this.vehicleId) {
        return this.getObjByPrimaryId(this.vehicleId, this.vehicles);
      } else if (!!this.driverId) {
        return this.getObjByPrimaryId(this.driverId, this.drivers);
      } else {
        return null;
      }
    },
    modelObj() {
      if (!!this.model) {
        return this.getObjByProp(this.model, "value", this.models);
      } else {
        return null;
      }
    }
  },
  watch: {
    model(val) {
      this.getResourceTypes();
      if (!val) {
        this.contractorId = null;
        this.vehicleId = null;
        this.driverId = null;
      } else {
        if (val == "contractor") {
          this.vehicleId = null;
          this.driverId = null;
        }
        if (val == "vehicle") {
          this.contractorId = null;
          this.driverId = null;
        }
        if (val == "driver") {
          this.contractorId = null;
          this.vehicleId = null;
        }
      }
    },
    subjectObj(val) {
      if (!!val) {
        this.showDetails = true;
      } else {
        this.showDetails = false;
      }
    }
  },
  mounted() {
    this.getResourceTypes();
  }
};
</script>

<style scoped>
.overlap-fab-compliance {
  right: 40px;
  bottom: -17px;
  position: absolute !important;
}
</style>


